// action
import {
    DELETE_ROLE_MODULE_MAPPING,
    DELETE_ROLE_MODULE_MAPPING_FAIL,
    DELETE_ROLE_MODULE_MAPPING_SUCCESS,
    DELETE_ROLE_MODULE_MAPPING_RESET
} from '../action/deleteRoleModuleMappingAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_ROLE_MODULE_MAPPING:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_ROLE_MODULE_MAPPING_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_ROLE_MODULE_MAPPING_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_ROLE_MODULE_MAPPING_RESET:
            return initialState
        default:
            return state
    }
}